import axios from "axios";

let config = {
  headers: { Authorization: `Bearer ${localStorage.getItem("__myTeken")}` },
};

export const verificationSolde = async (d) => {
  try {
    const { data } = await axios.post("dossier/vsoldeclt", d, config);
    return data;
  } catch (error) {
    return error;
  }
};

export const soumissionDossier = async (d) => {
  try {
    const { data } = await axios.post("dossier/soumdossclt", d, config);
    return data;
  } catch (error) {
    return error;
  }
};
